var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerateFailed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0001 5.83062C14.0015 5.36399 13.9096 4.9018 13.7297 4.47122C13.5498 4.04065 13.2857 3.65039 12.9528 3.32339C12.6199 2.9964 12.225 2.73928 11.7912 2.56714C11.3575 2.39501 10.8937 2.31135 10.4272 2.32107C9.96067 2.3308 9.5008 2.43371 9.07462 2.62377C8.64845 2.81382 8.26458 3.08718 7.9456 3.42776C7.62661 3.76834 7.37895 4.16927 7.21719 4.60697C7.05542 5.04467 6.98281 5.51029 7.00363 5.97646C6.31786 6.15278 5.68121 6.48285 5.1419 6.94166C4.60258 7.40046 4.17474 7.97598 3.89078 8.62461C3.60682 9.27325 3.47418 9.978 3.50291 10.6855C3.53165 11.393 3.721 12.0847 4.05663 12.7081C3.4665 13.1875 3.00246 13.8039 2.70486 14.5035C2.40725 15.2032 2.28511 15.965 2.34905 16.7226C2.41299 17.4802 2.66108 18.2108 3.07173 18.8507C3.48239 19.4905 4.04317 20.0204 4.70529 20.3941C4.62353 21.0267 4.67232 21.6694 4.84866 22.2824C5.025 22.8954 5.32514 23.4658 5.73054 23.9582C6.13595 24.4507 6.63801 24.8548 7.20572 25.1457C7.77343 25.4365 8.39473 25.6079 9.03127 25.6492C9.6678 25.6905 10.306 25.6009 10.9066 25.3858C11.5071 25.1708 12.0572 24.835 12.5228 24.399C12.9885 23.9631 13.3598 23.4363 13.6139 22.8512C13.868 22.2661 13.9994 21.6352 14.0001 20.9973V5.83062Z",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.1667C11.4795 14.8221 12.3348 14.1948 12.9578 13.3642C13.5808 12.5335 13.9435 11.5368 14 10.5",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00342 5.97656C7.02649 6.54092 7.1858 7.09131 7.46775 7.58073",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.05664 12.712C4.27007 12.5382 4.49846 12.3836 4.73914 12.25",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99991 21.0004C6.19588 21.0008 5.40539 20.7934 4.70508 20.3984",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15.1641H18.6667",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 21H21C21.6188 21 22.2123 21.2458 22.6499 21.6834C23.0875 22.121 23.3333 22.7145 23.3333 23.3333V24.5",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.33594H23.3333",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 9.33333V5.83333C18.6665 5.21449 18.9123 4.621 19.3499 4.18342C19.7875 3.74583 20.381 3.5 20.9998 3.5",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6668 15.7526C18.989 15.7526 19.2502 15.4914 19.2502 15.1693C19.2502 14.8471 18.989 14.5859 18.6668 14.5859C18.3447 14.5859 18.0835 14.8471 18.0835 15.1693C18.0835 15.4914 18.3447 15.7526 18.6668 15.7526Z",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9998 4.08073C21.322 4.08073 21.5832 3.81956 21.5832 3.4974C21.5832 3.17523 21.322 2.91406 20.9998 2.91406C20.6777 2.91406 20.4165 3.17523 20.4165 3.4974C20.4165 3.81956 20.6777 4.08073 20.9998 4.08073Z",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 25.0807C23.6555 25.0807 23.9167 24.8196 23.9167 24.4974C23.9167 24.1752 23.6555 23.9141 23.3333 23.9141C23.0112 23.9141 22.75 24.1752 22.75 24.4974C22.75 24.8196 23.0112 25.0807 23.3333 25.0807Z",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 9.91667C23.6555 9.91667 23.9167 9.6555 23.9167 9.33333C23.9167 9.01117 23.6555 8.75 23.3333 8.75C23.0112 8.75 22.75 9.01117 22.75 9.33333C22.75 9.6555 23.0112 9.91667 23.3333 9.91667Z",
    stroke: "#DC2626",
    strokeWidth: 2.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateFailed);
export default __webpack_public_path__ + "static/media/GenerateFailed.bb5e9330cfd22cb26122335b224746cd.svg";
export { ForwardRef as ReactComponent };